'use strict';

import React, {Component} from "react";
import  createReactClass from 'create-react-class';

import ValidationOverlayJsonForm from './validationOverlayJsonForm.jsx' ;
import FormElement from './NewFormElement.jsx';
import PopUp from "../../../commonModules/interface/PopUp.jsx";

class NewFormRegestering extends Component{

    state = {
        //Initiate Default User
        msg: "",
        popupStateValidation: false,
        uiSchema: {},
        name: "",
        jsonSchema: {
        "title": "A single-field form",
        "type": "string"
        },
    }  

    onValidationSucceed = (e) => {
        console.log('Record Json format End ');
        this.setState({
            popupStateValidation:false, 
            uiSchema: {},
            name: "Nom Schéma",
            jsonSchema: {
                "title": "A single-field form",
                "type": "string"
            }}
        );

        if(this.props.fetchSchemas) {
            this.props.fetchSchemas() 
        };
       
        this.props.onCloseOverlay();
    }
    // onClose = () => {
    //     console.log("Close Object");
    //     this.setState({ 
    //         msg: "", 
    //         popupState: this.props.popupState, 
    //         popupStateValidation: false, 
    //         uiSchema: {}, 
    //         name: "", 
    //         jsonSchema: { "title": "A single-field form", "type": "string" }, });
    //     //this.setState({popupState: false, popupStateValidation: false});
    //     this.props.onCloseOverlay();
    // }

    prepareRequest=  (request) => {
        console.log("[DEBUG],NewFormRegestering,prepareRequest,  ")
        this.setState({
            popupStateValidation: true,
            jsonSchema: request.jsonSchema,
            uiSchema: request.uiSchema,
            name: request.name,
        });        
    }
    render() {
        console.log('==============In New Form Register======================');
        console.log();
        console.log('====================================');
        return (
            <PopUp
                title="Enregistrer un nouveau Schema"
                block={true}
                close={this.props.onCloseOverlay}
            >
                <FormElement 
                    onClose={this.props.onCloseOverlay} 
                    validation={(request) => this.prepareRequest(request)} 
                    sav={this.props.sav} 
                />
            
            {this.state.popupStateValidation &&
                <ValidationOverlayJsonForm
                    jsonSchema={this.state.jsonSchema}
                    uiSchema={this.state.uiSchema}
                    name={this.state.name}
                    onValidation={this.onValidationSucceed}
                    onCancelation={() => this.setState({ popupStateValidation: false })}
                    report={this.props.report}
                    quotation={this.props.quotation}
                    sav={this.props.sav}
                    complementary={this.props.complementary}
                />
            }   
            </PopUp>
        )
    }
};

export default NewFormRegestering
